export default {
  article: {
    title: 'USFans Spreadsheet: The Complete Guide & Resource Hub',
    quickAnswerLabel: 'Quick Answer',
    quickAnswer: 'The USFans Spreadsheet is a single, organized resource that groups popular US fan merchandise and apparel into clear categories. Instead of opening dozens of tabs or guessing where to look, you can jump straight to shoes, hoodies, jerseys, and accessories through direct links — saving time and keeping your browsing tidy.',
    intro: 'Whether you are hunting for a specific jersey, browsing for new sneakers, or simply curious about what is available, the USFans Spreadsheet is designed to make discovery easy. This guide explains what the spreadsheet is, what you can find inside it, how to use it, and why it is a useful starting point for fans and shoppers alike.',
    secWhat: {
      title: 'What Is the USFans Spreadsheet?',
      p1: 'The USFans Spreadsheet is a curated, category-based directory of US-themed merchandise. It organizes popular product types — from footwear and headwear to accessories and fragrances — into a simple, browsable structure. Rather than a long, unstructured list, the spreadsheet uses clear groupings so you always know where to look.',
      p2: 'Think of it as a single entry point. Each category has its own direct link, which means you can move from the homepage to a focused collection in one click. The goal is to reduce friction and help you find what you want faster.',
    },
    secFind: {
      title: 'What You Can Find Inside',
      p1: 'The spreadsheet covers a broad range of apparel and accessory categories, including:',
    },
    secHow: {
      title: 'How to Use the USFans Spreadsheet',
      p1: 'Using the spreadsheet is simple. On the homepage, choose a category from the dropdown or tap any category card. You will be taken directly to the matching collection on the main website. Because every category has a dedicated, direct link, you skip the usual back-and-forth of searching and filtering.',
      p2: 'For the fastest experience, start with the dropdown when you know exactly what you want, and use the grid when you prefer to browse visually.',
    },
    secPopular: {
      title: 'Popular Categories to Explore',
      p1: 'Some categories are especially popular among visitors. Footwear is a frequent starting point for sneaker fans, while hoodies and sweaters remain a go-to for comfortable, everyday wear. Jerseys attract sports supporters, and accessories — from bags to belts — offer quick ways to complete an outfit.',
      p2: 'Perfumes and sets are also worth exploring if you want gift ideas or a coordinated look. Every category points to a dedicated collection, so you can dive into whichever area interests you most.',
    },
    secCompare: {
      title: 'USFans Spreadsheet vs. Manual Searching',
      p1: 'The table below compares using the USFans Spreadsheet against searching manually across multiple pages.',
      col1: 'USFans Spreadsheet',
      col2: 'Manual Searching',
      col3: 'Best For',
      r1factor: 'Organization',
      r1v1: 'High — clear categories',
      r1v2: 'Varies — depends on effort',
      r1best: 'Keeping things tidy',
      r2factor: 'Speed',
      r2v1: 'Fast — direct links',
      r2v2: 'Slower — many steps',
      r2best: 'Quick access',
      r3factor: 'Consistency',
      r3v1: 'Standardized structure',
      r3v2: 'Inconsistent',
      r3best: 'Repeat visits',
      r4factor: 'Learning curve',
      r4v1: 'Low',
      r4v2: 'Moderate',
      r4best: 'Beginners',
      r5factor: 'Updates',
      r5v1: 'Easy to refresh',
      r5v2: 'Manual',
      r5best: 'Staying current',
    },
    secTips: {
      title: 'Tips for Getting the Most Value',
      tip1: 'Start with the category that matches your goal — searching is fastest when you are specific.',
      tip2: 'Use the dropdown for quick jumps, and the grid for visual browsing.',
      tip3: 'Bookmark the homepage so you can return to the resource whenever you need it.',
      tip4: 'Check back for updated guides and new categories.',
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: 'What is the USFans Spreadsheet?',
      a1: 'It is a category-based directory that organizes popular US fan merchandise and apparel into a simple, browsable structure with direct links to each collection.',
      q2: 'Is the spreadsheet free to browse?',
      a2: 'Yes. Browsing the categories and reading the guides on this resource is completely free.',
      q3: 'How do I find a specific category?',
      a3: 'Use the dropdown on the homepage to jump to a category, or tap any category card in the grid.',
      q4: 'Do I need an account to use it?',
      a4: 'No account is required to browse the categories or read the guides.',
      q5: 'Where do the category links take me?',
      a5: 'Each category link takes you to the matching collection on our main website, where you can view the products in that category.',
    },
    related: {
      title: 'Continue Exploring',
      text: 'Head back to the homepage to browse all categories, or visit the main website directly.',
    },
    ctaButton: 'Visit Main Website',
    backHome: 'Back to the USFans Spreadsheet Hub',
    author: 'USFans Editorial Team',
    published: 'Published',
    updated: 'Updated',
  },
};